import { render, staticRenderFns } from "./ViewArticleInfo.vue?vue&type=template&id=61e46bf8&scoped=true&"
import script from "./ViewArticleInfo.vue?vue&type=script&lang=js&"
export * from "./ViewArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ViewArticleInfo.vue?vue&type=style&index=0&id=61e46bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e46bf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBadge,VCol,VContainer,VDivider,VIcon,VListItemSubtitle,VProgressLinear,VRow,VSpacer,VTreeview})
